<template>
  <div class="chat-modal" @keydown.esc="close">
    <c-sidesheet :active="active" @close="close">
      <div class="chat-modal__wrapper">
        <chat ref="chat" class="chat-modal__content" :entity="entity" :entity-id="entityId" :can-edit="canEdit" />
      </div>
    </c-sidesheet>
  </div>
</template>

<script>
import Sidesheet from "@/components/sidesheet";
import Chat from "./Chat";

export default {
  name: "m-filter-constructor",

  components: {
    "c-sidesheet": Sidesheet,
    Chat,
  },

  props: ["entity", "entityId", "canEdit"],

  data() {
    return {
      active: false,
    };
  },

  watch: {
    active(value) {
      if (!value) this.comments = [];
    },
  },

  created() {
    document.getElementsByTagName("body")[0].addEventListener("click", () => {
      this.$root.$emit("bv::hide::popover");
    });

    document.addEventListener("keyup", (evt) => {
      if (evt.keyCode === 27) {
        if (this.active) {
          this.close();
        }
      }
    });
  },

  methods: {
    open() {
      this.active = true;
    },
    close() {
      this.active = false;
      this.$emit("close");
      this.$refs.chat.deactivate();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
@import "~@/assets/styles/decoration";

.chat-modal {
  &__header {
    display: flex;
    justify-content: space-between;

    @media screen and (max-width: 700px) {
      flex-direction: column;
    }
  }

  &__title {
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 108%;
    color: #000000;

    @media screen and (max-width: 700px) {
      font-size: 18px;
    }
  }

  &__wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;

    @media screen and (max-width: 700px) {
      flex-grow: 1;
    }
  }

  &__content {
    flex-grow: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    position: relative;
    margin-left: -30px;
    margin-right: -30px;
    padding-left: 30px;
    padding-right: 30px;

    /deep/ {
      .comments-tree {
        flex-grow: 1;
        overflow: auto;
        width: calc(100% / 12 * 11);
        @include scrollbar;
      }

      .scroll-container__content {
        padding-bottom: 20px;
      }

      .shadow-bottom {
        &.active {
          display: none;
        }
      }

      .comment-form {
        margin-left: -30px;
        margin-right: -30px;
        padding: 15px 30px;
        flex-shrink: 0;
        border-top: 1px solid #dfe4ef;
      }

      .add-comment {
        flex-shrink: 0;
      }
    }
  }

  /deep/ {
    .comments-tree.scrolled ~ .comment-form {
      box-shadow: 0px 0px 15px rgba(0, 21, 80, 0.3);
    }
  }

  @media screen and (max-width: 700px) {
    &__content {
      /deep/ {
        .comments-tree {
          width: 100%;
          padding-left: 20px;
        }
      }
    }
  }
}

::v-deep {
  .sidesheet__wrapper {
    width: calc(100vw - 161px);
    padding: 20px 30px 0;

    @media screen and (max-width: 1024px) {
      width: calc(100vw - 62px);
    }

    @media screen and (max-width: 700px) {
      padding: 10px 0px 0px !important;
      max-width: 100%;
      width: 100%;
    }
  }

  .sidesheet__header {
    flex-basis: 0;
    display: none;
  }

  .sidesheet__content {
    height: 100%;
    display: flex;
    flex-direction: column;

    @media screen and (max-width: 700px) {
      overflow: hidden;
      padding: 0;
    }
  }

  .sidesheet__close {
    @media screen and (max-width: 700px) {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
}
</style>
